<div class="grid" [formGroup]="form">
  <div *ngIf="displayPrimaryEmail" class="col-12 sm:col-6">
    <aur-input
      formControlName="firstContact"
      id="firstContactEmailAddress"
      class="receipt-input-width no-margin-top"
      label="{{ 'ARC_PAYMENT_MY_RECEIPT_EMAIL' | translate }}"
      [disabled]="true"
      [errorMessages]="{
        invalidEmail: 'ARC_INVALID_EMAIL'
      }"
    ></aur-input>
  </div>
  <div class="{{ displayPrimaryEmail ? 'col-12 sm:col-6' : 'col-12' }}">
    <aur-input
      formControlName="remainingContacts"
      id="remainingContactEmailAddresses"
      class="receipt-input-width no-margin-top"
      [errorMessages]="{
        invalidEmail: 'ARC_INVALID_EMAIL'
      }"
      label="{{
        (displayPrimaryEmail
          ? 'ARC_PAYMENT_SEND_PAYMENT_RECEIPT_TO'
          : 'ARC_PAYMENT_MY_RECEIPT_EMAIL'
        ) | translate
      }}"
    ></aur-input>
  </div>
</div>
